import styled from '@emotion/styled'
import React from 'react'

import FormRow from './FormRow'
import { formControlReset } from 'styles/reset'

type Props = JSX.IntrinsicElements['input'] & {
	label: React.ReactNode
}

const StyledRadio = styled.input`
	${formControlReset};
	margin: 0;
	color: currentColor;
	width: 1.25em;
	height: 1.25em;
	border-radius: 50%;
	border: 8px solid transparent;
	background-color: ${({ theme }) => theme.colors.light.surfaceDecorative};
	transition: border-width 200ms ${({ theme }) => theme.transitions.easings.css.spring};
	cursor: pointer;

	&:checked {
		border: 5px solid currentColor;
		background-color: ${({ theme }) => theme.colors.light.surface};
	}

	&:focus {
		outline-style: solid;
		outline-width: 1px;
		outline-color: ${({ theme }) => theme.colors.light.surfaceInteractive};
	}
`

export const RadioLabel = styled.label`
	${({ theme }) => theme.typography.paragraph}
	cursor: pointer;
`

const Radio = React.forwardRef<HTMLInputElement, Props>(({ label, ...restProps }, ref) => {
	const id = React.useId()
	return (
		<FormRow>
			<StyledRadio type="radio" {...restProps} id={id} ref={ref} />
			<RadioLabel htmlFor={id}>{label}</RadioLabel>
		</FormRow>
	)
})

Radio.displayName = 'Radio'

export default Radio
